import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import path from "../../routes/path";
import {pageTitle} from "../../helper/CommonFunctions";
import  "./maintainence.scss"
import siteConfig from "../../config/site-config";
const Maintenance = (props) => {
    const {t} = useTranslation();
    let SiteName = `| ${siteConfig.company_name}`;
    let pageTitleString = `Maintenance ${SiteName}`;
    pageTitle(pageTitleString)


    return (
        <Fragment>
            {/*<div className="page-wrapper">*/}
            {/*    <div className="error-wrapper maintenance-bg">*/}
            {/*        <div className="container">*/}
            {/*            <ul className="maintenance-icons">*/}
            {/*                <li><i className="fa fa-cog"/></li>*/}
            {/*                <li><i className="fa fa-cog"/></li>*/}
            {/*                <li><i className="fa fa-cog"/></li>*/}
            {/*            </ul>*/}
            {/*            <div className="maintenance-heading">*/}
            {/*                <h2 className="headline">{t('maintenance')}</h2>*/}
            {/*            </div>*/}
            {/*            <h4 className="sub-content">{t('maintenance_p1')} <br />*/}
            {/*                {t('maintenance_p2')}</h4>*/}
            {/*            /!*<div><Link className="btn btn-info-gradien btn-lg text-light" to={`${process.env.PUBLIC_URL}${path.dashboard}`}>{t('back_to_home_page')}</Link></div>*!/*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="container">
                <div className="what-is-up">

                    <div className="spinny-cogs">
                        <i className="fa fa-cog" aria-hidden="true"></i>
                        <i className="fa fa-5x fa-cog fa-spin" aria-hidden="true"></i>
                        <i className="fa fa-3x fa-cog" aria-hidden="true"></i>
                    </div>
                    <h1 className="maintenance">Under Maintenance</h1>
                    <h2>Our developers are hard at work updating your system. Please wait while we do this. We have also
                        made the spinning cogs to distract you.</h2>
                </div>
            </div>
        </Fragment>
    );
};

export default Maintenance;
